import { useContext, useEffect } from 'react';
import { Grid, Typography, MenuItem } from '@material-ui/core';
import { useFormikContext, Field, FieldArray } from "formik";
import { IssueServiceType } from "helpers/enums";
import { TextField } from "formik-material-ui";
import { DatePicker } from "formik-material-ui-pickers";
import { EditRequest } from "./EditRequest"
import { ProductSearch } from 'components';
import { applicationContext } from 'helpers/services';
import { ticketContext } from 'views/Ticket/TicketContext';
import { KeyValuePair } from 'helpers';


let DeliveryInfo = () => {
    let { issueServiceTypes } = useContext(applicationContext);
    let service = useContext(ticketContext);

    let form = useFormikContext<EditRequest>();


    useEffect(() => {
        if (form.values.numberOfPackages) {
            let value = parseInt(form.values.numberOfPackages);
            let length = form.values.packageNumbers.length;

            if (value > 99)
                form.setFieldError("numberOfPackages", "Value not valid");

            if (value < 100 && value !== length) {
                // se il numero di pacchetti è minore del numero di textfield rimuovo l'ultimo
                // se è maggiore ne aggiungo uno
                if (value < length) {
                    let diff = length - value;
                    for (let i = 0; i < diff; i++)
                        form.values.packageNumbers.pop();
                }
                else {
                    let diff = value - length;
                    for (let i = 0; i < diff; i++)
                        form.values.packageNumbers.push('');
                }
            }
        }

    }, [form.values.packageNumbers, form.values.numberOfPackages])


    return (
        <>
            <Grid container>
                <Grid item xs={12}>
                    <Typography variant="body2" color="textSecondary">Delivery info</Typography>
                </Grid>
                <Grid item xs={12}>
                    <Field
                        component={TextField}
                        name="deliveryNote"
                        variant="outlined"
                        fullWidth
                        label="Delivery Note"
                    />
                </Grid>
            </Grid>
            <Grid container>
                <Grid item xs>
                    <Field
                        component={DatePicker}
                        name="invoiceDate"
                        fullWidth
                        format="LL"
                        inputVariant="outlined"
                        label="Invoice Date"
                    />
                </Grid>
                <Grid item xs>
                    <Field
                        component={TextField}
                        name="invoiceNumber"
                        fullWidth
                        variant="outlined"
                        label="Invoice Number"
                    />
                </Grid>
                <Grid item xs>
                    <Field
                        component={TextField}
                        name="invoiceQuantity"
                        fullWidth
                        variant="outlined"
                        label="Invoice Quantity"
                        type="number"
                        step="0"
                    />
                </Grid>
            </Grid>

            <Grid container>
                <Grid item xs={12}>
                    <Field
                        component={TextField}
                        select
                        name="issueServiceType"
                        label="Issue service type"
                        variant="outlined"
                        fullWidth
                    >
                        {issueServiceTypes.map(issue =>
                            <MenuItem key={issue.key} value={issue.key}>{issue.value}</MenuItem>
                        )}
                    </Field>
                </Grid>
            </Grid>

            {(form.values.issueServiceType === IssueServiceType.DamagedPackages
                || form.values.issueServiceType === IssueServiceType.MissingPackages) &&
                <FieldArray name="packageNumbers">
                    {({ insert, remove }) =>
                        <>
                            <Grid container>
                                <Grid item xs={5}>
                                    <Field
                                        component={TextField}
                                        name="numberOfPackages"
                                        fullWidth
                                        variant="outlined"
                                        inputProps={{ max: 99 }}
                                        label="Number of packages"
                                        type="number"
                                    />
                                </Grid>
                            </Grid>
                            {form.values.packageNumbers
                                .map((pkNumber, index) =>
                                    <Grid container key={index}>
                                        <Grid item xs={5}>
                                            <Field
                                                label="Package number"
                                                component={TextField}
                                                name={`packageNumbers[${index}]`}
                                                fullWidth
                                                variant="outlined"
                                                type="number"
                                            />
                                        </Grid>
                                    </Grid>
                                )}
                        </>
                    }
                </FieldArray>
            }

            {(form.values.issueServiceType === IssueServiceType.OvershippedItems
                || form.values.issueServiceType === IssueServiceType.MissingItems
                || form.values.issueServiceType === IssueServiceType.DamagedItems) &&
                <Grid container>
                    <Grid item xs={8}>
                        <ProductSearch
                            label="Product"
                            freeSolo={false}
                            value={{
                                value: form.values.productSku,
                                label: `${form.values.productSku} ${form.values.productDescription}`.trim(),
                                brand: form.values.productBrand,
                                shortDescription: form.values.productDescription,
                                sku: form.values.productSku,
                                hasSerialNumber: form.values.hasSerialNumber,
                                suppliers: service.productSuppliers
                            }}
                            onChange={(sku: string, brand: string, description: string, hasSerialNumber: boolean, suppliers: KeyValuePair<string, string>[]) => {
                                form.setFieldValue('productSku', sku);
                                form.setFieldValue('productBrand', brand);
                                form.setFieldValue('productDescription', description);
                                form.setFieldValue('hasSerialNumber', hasSerialNumber);

                                service.updateProductSuppliers(suppliers);
                            }}
                            error={Boolean(form.touched.productSku && form.errors.productSku)}
                            helperText={form.touched.productSku ? form.errors.productSku : ''}
                        />
                    </Grid>
                    {(form.values.issueServiceType === IssueServiceType.OvershippedItems
                        || form.values.issueServiceType === IssueServiceType.MissingItems) &&
                        <Grid item xs>
                            <Field
                                component={TextField}
                                name="receivedQuantity"
                                fullWidth
                                variant="outlined"
                                label="Received quantity"
                                type="number"
                            />
                        </Grid>
                    }
                    {form.values.issueServiceType === IssueServiceType.DamagedItems &&
                        <Grid item xs>
                            <Field
                                component={TextField}
                                name="damagedItemQuantity"
                                fullWidth
                                variant="outlined"
                                label="Damaged item quantity"
                                type="number"
                            />
                        </Grid>
                    }
                    {service.productSuppliers.length > 1 && (!service.ticket.productSupplierCode || service.ticket.productSupplierCode === '') &&
                        <Grid item xs={12}>
                            <Field
                                component={TextField}
                                select
                                name="productSupplierCode"
                                variant="outlined"
                                fullWidth
                                label="Product supplier"
                                onChange={(e: any) => {
                                    form.setFieldValue('productSupplierCode', e.target.value);
                                    form.setFieldValue('productSupplierName', service.productSuppliers.getValueByKey(e.target.value));
                                }}
                            >
                                <MenuItem key='' value=''>Any</MenuItem>
                                {service.productSuppliers.map((supplier, supplierIdx) =>
                                    <MenuItem key={supplierIdx} value={supplier.key}>{supplier.value}</MenuItem>
                                )}
                            </Field>
                        </Grid>
                    }
                </Grid>
            }
        </>
    )
}

export default DeliveryInfo;